import React from 'react';
import { Box, Container, Grid, Typography, Stack } from '@mui/material';
import { nav, contact } from '../data';

const Footer = () => (
  <Box component="footer" sx={{ bgcolor: 'primary.dark', color: '#fff', pt: 8, pb: 4 }}>
    <Container maxWidth="lg">
      <Grid container spacing={5}>
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              display: 'inline-flex',
              bgcolor: '#ffffff',
              borderRadius: '10px',
              px: 1.5,
              py: 0.8,
              mb: 2.5,
              boxShadow: '0 2px 12px rgba(0,0,0,0.3)',
            }}
          >
            <Box
              component="img"
              src="/logo.png"
              alt="Shree Bhavani Group of Institutions"
              sx={{ height: 60, width: 'auto', objectFit: 'contain', display: 'block' }}
            />
          </Box>
          <Typography sx={{ color: 'rgba(255,255,255,0.7)', lineHeight: 1.7, maxWidth: 380 }}>
            Managed by The St. Lords Educational Trust. Affiliated with RGUHS, the Karnataka State Paramedical Board and the Karnataka State Nursing Council.
          </Typography>
        </Grid>

        <Grid item xs={6} md={2}>
          <Typography variant="h6" sx={{ mb: 2, fontSize: '1rem' }}>Explore</Typography>
          <Stack spacing={1}>
            {nav.map(([l, id]) => (
              <Typography key={id} component="a" href={`#${id}`} sx={{ color: 'rgba(255,255,255,0.75)', textDecoration: 'none', '&:hover': { color: 'secondary.main' } }}>{l}</Typography>
            ))}
          </Stack>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography variant="h6" sx={{ mb: 2, fontSize: '1rem' }}>Contact Us</Typography>
          <Stack spacing={1.5} sx={{ color: 'rgba(255,255,255,0.75)' }}>

            <Box>
              <Typography sx={{ fontWeight: 600, color: '#fff', fontSize: '0.8rem', textTransform: 'uppercase', letterSpacing: '0.06em', mb: 0.4 }}>
                Corporate Office
              </Typography>
              <Typography sx={{ lineHeight: 1.6 }}>
                {contact.corporateAddress}
              </Typography>
            </Box>

            <Box>
              <Typography sx={{ fontWeight: 600, color: '#fff', fontSize: '0.8rem', textTransform: 'uppercase', letterSpacing: '0.06em', mb: 0.4 }}>
                Campus &amp; Hospital
              </Typography>
              <Typography sx={{ lineHeight: 1.6 }}>
                {contact.campusAddress}
              </Typography>
            </Box>

            <Box>
              <Typography sx={{ fontWeight: 600, color: '#fff', fontSize: '0.8rem', textTransform: 'uppercase', letterSpacing: '0.06em', mb: 0.4 }}>
                Phone
              </Typography>
              <Typography
                component="a"
                href="tel:+919886170470"
                sx={{ color: 'rgba(255,255,255,0.75)', textDecoration: 'none', '&:hover': { color: 'secondary.main' } }}
              >
                {contact.phone}
              </Typography>
            </Box>

            <Box>
              <Typography sx={{ fontWeight: 600, color: '#fff', fontSize: '0.8rem', textTransform: 'uppercase', letterSpacing: '0.06em', mb: 0.4 }}>
                Email
              </Typography>
              <Typography
                component="a"
                href={`mailto:${contact.email}`}
                sx={{ color: 'rgba(255,255,255,0.75)', textDecoration: 'none', '&:hover': { color: 'secondary.main' } }}
              >
                {contact.email}
              </Typography>
            </Box>

          </Stack>
        </Grid>
      </Grid>

      <Typography sx={{ mt: 6, pt: 3, borderTop: '1px solid rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.55)', fontSize: '0.875rem' }}>
        © {new Date().getFullYear()} Shree Bhavani Group of Institutions. All rights reserved.
      </Typography>
    </Container>
  </Box>
);

export default Footer;

